import { CareerDevIcon, SmallCareerDevIcon } from "./svgs";

const Internships = [
  {
    title: "Future Tech Internship Program",
    field: "",
    icon: CareerDevIcon,
    smallIcon: SmallCareerDevIcon,
    location: "Lahore, Pak",
    timing: "Internship",
    tech: "Engineering",
    positions: "02",
  },
];
export default Internships;
